if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        init() {
          this.setupAllSliderProgress();

          const observer = new MutationObserver(() => {
            this.setupAllSliderProgress();
          });

          observer.observe(container, {
            childList: true,
            subtree: true
          });
        },
        select(index) {
          this.currentTab = index;
          this.$nextTick(() => this.setupAllSliderProgress());
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
              this.setupAllSliderProgress();
            })
          }
        },
        setupAllSliderProgress() {
          container.querySelectorAll('[data-featured-collection-slider]').forEach((sliderRoot) => {
            this.setupSliderProgress(sliderRoot);
          });
        },
        setupSliderProgress(sliderRoot) {
          if (sliderRoot.dataset.progressReady === 'true') {
            return;
          }

          const progressTrack = sliderRoot.querySelector('[data-carousel-progress]');
          if (!progressTrack) {
            return;
          }

          const bindProgress = () => {
            const splide = sliderRoot.splide;
            if (!splide || typeof splide.go !== 'function' || !splide.Components?.Controller) {
              return false;
            }

            sliderRoot.dataset.progressReady = 'true';
            progressTrack.style.touchAction = 'none';

            const goToPointerPosition = (clientX) => {
              const rect = progressTrack.getBoundingClientRect();
              if (!rect.width) {
                return;
              }

              const rawRatio = (clientX - rect.left) / rect.width;
              const ratio = Math.min(Math.max(rawRatio, 0), 1);
              const perPage = Number(splide.options?.perPage) || 1;
              const maxStartIndex = Math.max(splide.length - Math.ceil(perPage), 0);
              const targetIndex = Math.round(ratio * maxStartIndex);

              splide.go(targetIndex);
            };

            let isDragging = false;

            progressTrack.addEventListener('pointerdown', (event) => {
              isDragging = true;
              progressTrack.setPointerCapture?.(event.pointerId);
              goToPointerPosition(event.clientX);
            });

            progressTrack.addEventListener('pointermove', (event) => {
              if (!isDragging) {
                return;
              }

              goToPointerPosition(event.clientX);
            });

            const stopDragging = (event) => {
              isDragging = false;
              progressTrack.releasePointerCapture?.(event.pointerId);
            };

            progressTrack.addEventListener('pointerup', stopDragging);
            progressTrack.addEventListener('pointercancel', stopDragging);

            return true;
          };

          if (bindProgress()) {
            return;
          }

          let attempts = 0;
          const timer = window.setInterval(() => {
            attempts += 1;
            if (bindProgress() || attempts > 40) {
              window.clearInterval(timer);
            }
          }, 250);
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}
